import React, {Component} from 'react';
import {Problems} from './Problems';

export class Home extends Component {
    static displayName = Home.name;

    render() {
        return <Problems/>;
    }
}
